import React from 'react';
import { ReactComponent as Photo } from 'assert/images/Home/photo.svg';
import { ReactComponent as Vedio } from 'assert/images/Home/video.svg';
import { ReactComponent as Document } from 'assert/images/Home/document.svg';
import { ReactComponent as ThumbUp } from 'assert/images/Common/thumbUp.svg';
import { ReactComponent as ThumbUpFilled } from 'assert/images/Common/thumbUpFilled.svg';
import { ReactComponent as Comment } from 'assert/images/Home/comment.svg';
import { ReactComponent as DetailPost } from 'assert/images/Jobs/viewList.svg';

const currentDate = new Date();
const currentYear = currentDate.getFullYear();

const YearList = [];
let startYear = 1900;
while (startYear <= currentYear) {
  YearList.push({
    id: startYear,
    label: startYear,
    value: startYear,
  });
  startYear++;
}

const fieldOptionList = [
  {
    value: 'Free Text',
    label: 'Free Text',
  },
  {
    value: 'Dropdown',
    label: 'Dropdown',
  },
  {
    value: 'Radio Button',
    label: 'Radio Button',
  },
  {
    value: 'Date Picker',
    label: 'Date Picker',
  },
  {
    value: 'File Upload',
    label: 'File Upload',
  },
];

const GenderList = [
  {
    id: '1',
    label: 'Male',
    value: 'Male',
  },
  {
    id: '2',
    label: 'Female',
    value: 'Female',
  },
  {
    id: '3',
    label: 'Rather not say',
    value: 'Rather not say',
  },
];

const CommentList = [
  {
    id: '1',
    label: 'HomePage.AnyOneCanComment',
    value: 'true',
  },
  {
    id: '2',
    label: 'HomePage.DisableTheComment',
    value: 'false',
  },
];

const ProfileLimit = {
  maxLimitProfile: 30,
  addmoreLimit: 10,
  companyMaxSize: 8,
};

const IconList = [
  { icon: <Photo className="icon" />, title: 'Photo', type: 'img' },
  { icon: <Vedio className="icon" />, title: 'Video', type: '' },
  { icon: <Document className="icon" />, title: 'Document', type: '' },
];

const ActionList = [
  { icon: <Comment className="commentIcon" />, value: 0, title: 'Comment' },
  {
    icon: <ThumbUp className="thumbIcon" />,
    filledIcon: <ThumbUpFilled className="thumbIcon" />,
    title: 'Like',
  },
  {
    icon: <DetailPost className="detailIcon" />,
    title: 'Detail',
  },
];

const OptionList = [
  { icon: <Comment />, value: 0, title: 'Comment' },
  {
    icon: <ThumbUp />,
    filledIcon: <ThumbUpFilled />,
    title: 'Like',
  },
];

const experienceArr = [...Array(19)].map((_, index) => index + 1 + '');
const ExperienceList = [...experienceArr, '20+'];

const companySizeList = [
  {
    id: '1',
    label: '0 - 10 employees',
    value: '1',
  },
  {
    id: '2',
    label: '11 - 50 employees',
    value: '2',
  },
  {
    id: '3',
    label: '51 - 100 employees',
    value: '3',
  },
  {
    id: '4',
    label: '101 - 200 employees',
    value: '4',
  },
  {
    id: '5',
    label: '201 - 500 employees',
    value: '5',
  },
  {
    id: '6',
    label: '501 - 1,000 employees',
    value: '6',
  },
  {
    id: '7',
    label: '1,001 - 5,000 employees',
    value: '7',
  },
  {
    id: '8',
    label: '5,000+ employees',
    value: '8',
  },
];

const DateList = [...Array(31)].map((_, index) => {
  const dateIndex = index + 1;
  return {
    id: dateIndex,
    label: dateIndex,
    value: dateIndex,
  };
});

const MonthList = [
  'January',
  'February',
  'March',
  'April',
  'May',
  'June',
  'July',
  'August',
  'September',
  'October',
  'November',
  'December',
].map((item, index) => {
  return {
    id: index + 1,
    label: item,
    value: index + 1,
  };
});

const LanguageList = [
  { value: 'en', label: 'English' },
  { value: 'es', label: 'Español (Spanish)' },
  { value: 'zh-cn', label: '中文 (Chinese)' },
  { value: 'ar', label: 'العربية (Arabic)' },
  { value: 'hi', label: 'हिन्दी (Hindi)' },
  { value: 'pt', label: 'Português (Portuguese)' },
  { value: 'ru', label: 'Русский (Russian)' },
  { value: 'bn', label: 'বাংলা (Bengali)' },
  { value: 'fr', label: 'Français (French)' },
  { value: 'de', label: 'Deutsch (German)' },
  { value: 'ja', label: '日本語 (Japanese)' },
  { value: 'ko', label: '한국어 (Korean)' },
  { value: 'tr', label: 'Türkçe (Turkish)' },
  { value: 'vi', label: 'Tiếng Việt (Vietnamese)' },
  { value: 'th', label: 'ไทย (Thai)' },
  { value: 'ur', label: 'اردو (Urdu)' },
  { value: 'id', label: 'Bahasa Indonesia' },
  { value: 'it', label: 'Italiano (Italian)' },
  { value: 'fa', label: 'فارسی (Persian)' },
  { value: 'tl', label: 'Filipino (Tagalog)' },
];

const timeMapping = {
  second: 'sec',
  seconds: 'sec',
  minute: 'min',
  minutes: 'min',
  hour: 'hr',
  hours: 'hr',
  day: 'day',
  days: 'day',
  week: 'wk',
  weeks: 'wk',
  month: 'mo',
  months: 'mo',
  year: 'yr',
  years: 'yr',
};

export {
  IconList,
  fieldOptionList,
  GenderList,
  ActionList,
  OptionList,
  ExperienceList,
  companySizeList,
  ProfileLimit,
  DateList,
  MonthList,
  YearList,
  CommentList,
  LanguageList,
  timeMapping,
};
